import FAQs from './FAQs'

export default FAQs;